<script lang="ts" setup generic="T extends string | Slide | ImageSlide">
import type { ImageSlide, Slide } from '~/types/elementsUi'

interface TestimonialCarouselProps {
  type?: 'image' | 'video'
  slides: T[]
  title?: string
  hideDivider?: boolean
  srLabel?: string
}

const props = withDefaults(defineProps<TestimonialCarouselProps>(), {
  type: 'image',
  title: 'components.experiences-of-others.title'
})
</script>

<template>
  <VSection :hide-divider :title>
    <template #content>
      <TestimonialCarousel
        :type
        :slides
        :sr-label="srLabel ?? `${title}-carousel-aria`"
      />
    </template>
  </VSection>
</template>

<style scoped></style>
